import React from 'react';
import FinBadge from './finance/fin-badge';
import { groupRequirements } from './connect-requirements';

// What Stripe has confirmed about this account, in the three facts a
// restaurant actually asks about — the mock's status strip (spec
// 2026-09-21 §5.4): one card, three cells with hairlines between them, a
// label and a pill each.
//
// The tones are the Finance palette, which is also what appearanceFor
// (use-connect-instance.js) now hands Stripe's iframe below, so the strip
// and the panel speak one language rather than two.
const outstandingCount = (requirements) =>
  (groupRequirements(requirements) || []).reduce((total, group) => total + (group?.items?.length || 0), 0);

const Fact = ({ label, ok, okLabel, notLabel, last = false }) => (
  <div className={`flex flex-col items-start gap-1.5 px-6 py-4 ${last ? '' : 'sm:border-r sm:border-fin-hair'}`}>
    <p className="text-[12.5px] font-medium text-fin-muted">{label}</p>
    <FinBadge tone={ok ? 'available' : 'pending'} label={ok ? okLabel : notLabel} dot={ok} size="lg" />
  </div>
);

const ConnectAccountStrip = ({ status }) => {
  if (!status?.hasAccount) return null;
  const outstanding = outstandingCount(status.requirements);

  return (
    <div className="grid grid-cols-1 rounded-xl border border-fin-border bg-fin-surface sm:grid-cols-3">
      <Fact label="Taking payments" ok={!!status.chargesEnabled} okLabel="Active" notLabel="Not yet" />
      <Fact label="Receiving payouts" ok={!!status.payoutsEnabled} okLabel="Active" notLabel="Not yet" />
      <Fact
        label="Verification"
        ok={outstanding === 0}
        okLabel="Complete"
        notLabel={`${outstanding} ${outstanding === 1 ? 'item' : 'items'} outstanding`}
        last
      />
    </div>
  );
};

export default ConnectAccountStrip;
